/** Minimal user shape for display helpers (org users, opportunity reps, etc.). */
export interface DisplayUser {
  id: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  is_active?: boolean;
}

export const userDisplayName = (user: DisplayUser): string =>
  `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim() || user.email || `User ${user.id}`;

export const userInitials = (user: DisplayUser): string => {
  const initials = `${user.first_name?.[0] ?? ''}${user.last_name?.[0] ?? ''}`.toUpperCase();
  return initials || (user.email?.[0] ?? '?').toUpperCase();
};
